function PlanTitle({ pricingPlan: { title } }) {
  return (
    <div className="header-title">{title}</div>
  )
}

export default PlanTitle
